import { hotArticles } from "@/mocks/articles";
import { reviews } from "@/mocks/reviews";
import ArticleCard from "@/components/feature/ArticleCard";

export default function TrendingSection() {
  const trendingArticles = hotArticles.slice(0, 5);

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 mb-5">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line text-accent-600 text-xs"></i>
            </span>
            <span className="text-xs font-medium text-accent-700 tracking-wide">热搜榜单 · 网友热议</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            大家正在<span className="text-accent-600">热议</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            来看看哪些爆料正在引发全民讨论
          </p>
        </div>

        {/* Hot articles in 3 col */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
          {trendingArticles.slice(0, 3).map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>

        {/* Reviews section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Text reviews - left & middle */}
          {reviews.slice(0, 2).map((review) => (
            <div
              key={review.id}
              className="bg-secondary-50/80 rounded-2xl p-6 flex flex-col justify-between"
            >
              <div>
                <span className="w-8 h-8 flex items-center justify-center mb-4">
                  <i className="ri-double-quotes-l text-2xl text-secondary-300"></i>
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed line-clamp-4">
                  {review.content}
                </p>
              </div>
              <div className="flex items-center gap-3 mt-6 pt-4 border-t border-secondary-200/60">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-400">{review.role}</p>
                </div>
              </div>
            </div>
          ))}

          {/* Photo card - right */}
          <div className="bg-background-50 rounded-2xl overflow-hidden h-full relative">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20newsroom%20scene%20with%20warm%20golden%20light%2C%20editorial%20journalism%20atmosphere%2C%20people%20discussing%20breaking%20news%2C%20professional%20media%20environment%2C%20warm%20amber%20tones%2C%20cinematic%20style%2C%20soft%20atmospheric%20lighting&width=600&height=800&seq=trend-photo-2026&orientation=portrait"
              alt="51黑料网网友热议"
              title="51黑料网 - 网友热议"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/40 to-transparent p-6">
              <p className="text-white font-semibold text-sm">加入热议</p>
              <p className="text-white/70 text-xs mt-1">数百万网友正在51黑料网讨论最新爆料</p>
            </div>
          </div>
        </div>

        {/* Bottom row: wide photo card + two small text cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
          {/* Wide photo card - spans 1.5 cols effectively */}
          <div className="md:col-span-2 bg-background-50 rounded-2xl overflow-hidden relative h-64 md:h-72">
            <img
              src="https://readdy.ai/api/search-image?query=Large%20group%20of%20people%20in%20modern%20urban%20setting%20discussing%20and%20sharing%20news%2C%20documentary%20style%2C%20warm%20natural%20lighting%2C%20social%20media%20age%20theme%2C%20editorial%20photography%2C%20clean%20composition%2C%20dynamic%20atmosphere&width=800&height=400&seq=trend-wide-2026&orientation=landscape"
              alt="51黑料网用户口碑"
              title="51黑料网 - 用户口碑"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-transparent p-6">
              <p className="text-white text-sm font-heading font-semibold">「做媒体这么多年，51黑料网是我见过最敢说真话的平台。」</p>
              <div className="flex items-center gap-2 mt-2">
                <p className="text-white/80 text-xs">— 张先生，媒体从业者</p>
              </div>
            </div>
          </div>

          {/* Two stacked small cards */}
          <div className="flex flex-col gap-6">
            {reviews.slice(2, 4).map((review) => (
              <div
                key={review.id}
                className="bg-secondary-50/80 rounded-2xl p-5 flex-1 flex flex-col justify-between"
              >
                <div>
                  <span className="w-7 h-7 flex items-center justify-center mb-3">
                    <i className="ri-double-quotes-l text-xl text-secondary-300"></i>
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed line-clamp-3">
                    {review.content}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-4 pt-3 border-t border-secondary-200/60">
                  <div className="w-8 h-8 rounded-full overflow-hidden shrink-0">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-400">{review.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}